<template>
  <div :class="['permission-denied-wrapper', variant]">
    <p class="header-text">
      <slot name="header" />
    </p>
    <div
      :class="[
        'content',
        {
          'content-height': !!$slots.header,
        },
      ]"
    >
      <BaseIcon v-if="!noIcon" name="lock" />
      <h4 v-if="props.showTitle" class="title">
        {{ t('permission-denied') }}
      </h4>
      <p v-if="props.showSubTitle" class="sub-text">
        {{ t('please-contact-admin-info') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import {
  PermissionDeniedProps,
  PermissionDeniedPropsVariant,
} from '@/rex-components/PermissionDenied/PermissionDenied.type';

const { t } = useI18n();

const props = withDefaults(defineProps<PermissionDeniedProps>(), {
  showTitle: true,
  showSubTitle: true,
  variant: PermissionDeniedPropsVariant.SOLID,
  noIcon: false,
});
</script>

<style lang="scss">
.permission-denied-wrapper {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;

  .header-text {
    text-align: left;
    font-weight: 600;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .title {
    @include heading-text;
  }

  .content-height {
    height: calc(100% - 18px);
  }

  .sub-text {
    color: $font-light-gray;
    font-size: 1rem;
  }
}

.solid {
  background-color: $bg-secondary;
}

.translucent {
  background-color: rgba($color: $bg-secondary, $alpha: 0.7);
}

.dark {
  background-color: $bg-dark-black;
}
</style>
